module.exports = __webpack_public_path__ + "img/logoTiho.9d58314e.png";